import { NgModule, Directive, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[ngx-google-places-autocomplete]',
  standalone: true,
})
export class GooglePlaceDirective {
  @Input() options: any;
  @Output() addressChange = new EventEmitter<any>();
}

@NgModule({
  imports: [GooglePlaceDirective],
  exports: [GooglePlaceDirective],
})
export class GooglePlaceModule { }

export default GooglePlaceModule;
